import React, { useEffect, useState } from 'react';
import GlovalCard from '../../../../components/atoms/GlovalCard/GlovalCard';
import InputCalendario from '../../../../components/atoms/InputCalendario/InputCalendario';
import Button from '../../../../components/atoms/Button/Button';
import ButtonGris from '../../../../components/atoms/ButtonGris/ButtonGris';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getTurnoHoy } from '../CierreDeTurnoIntegracion';

const TablaCierres = ({
    registros,
    registrosLoading,
    fechaInicio,
    setFechaInicio,
    fechaFin,
    setFechaFin,
    onBuscar,
    onNuevo,
    onVer,
}) => {
    const accionesTpl = (row) => (
        <ButtonGris onClick={() => onVer(row)} width="80px">Ver</ButtonGris>
    );
    const [turnoRegistrado, setTurnoRegistrado] = useState(false);
    const [loadingTurno, setLoadingTurno] = useState(true);

    useEffect(() => {
        getTurnoHoy().then((res) => {
            setTurnoRegistrado(res?.turno_registrado ?? false);
            setLoadingTurno(false);
        });
    }, [])
    return (
        <GlovalCard>
            {/* Filtros */}
            <div className="filtros">
                <InputCalendario
                    titulo="Fecha Inicio"
                    value={fechaInicio}
                    onChange={(e) => setFechaInicio(e.target.value)}
                />
                <InputCalendario
                    titulo="Fecha Fin"
                    value={fechaFin}
                    onChange={(e) => setFechaFin(e.target.value)}
                />
                <Button onClick={onBuscar} width="fit-content" className="botonBuscar">
                    Buscar
                </Button>
            </div>

            {/* Encabezado tabla */}
            <div className="tablaHeader">
                {loadingTurno
                    ? <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.4rem', color: 'var(--gris5)' }} />
                    : !turnoRegistrado && (
                        <Button onClick={onNuevo} width="fit-content">
                            + Nuevo Cierre
                        </Button>
                    )
                }
            </div>

            <DataTable
                value={registros}
                loading={registrosLoading}
                emptyMessage="Sin registros"
                size="small"
                stripedRows
                scrollable
                className="dashDataTable"
            >
                <Column field="ID" header="ID" sortable style={{ width: '55px' }} />
                <Column field="FECHA" header="Fecha" sortable style={{ width: '110px' }} />
                <Column field="NOMBRE" header="Nombre" sortable style={{ minWidth: '160px' }} />
                <Column field="PUESTO" header="Puesto" sortable style={{ minWidth: '140px' }} />
                <Column field="TOTAL_OPERADOR" header="Incidencia Operador" sortable style={{ width: '60px', textAlign: 'center' }} />
                <Column field="TOTAL_GENERALES" header="Incidencia General" sortable style={{ width: '60px', textAlign: 'center' }} />
                <Column field="TOTAL_EXCESOS" header="Exceso de Velocidad" sortable style={{ width: '75px', textAlign: 'center' }} />
                <Column field="TOTAL_TAXIS" header="Taxis" sortable style={{ width: '60px', textAlign: 'center' }} />
                <Column field="TOTAL_UNIDADES_INCORRECTAS" header="Unidad Incorrecta" sortable style={{ width: '80px', textAlign: 'center' }} />
                <Column field="TOTAL_EXCEPCIONES" header="Excepciones" sortable style={{ width: '70px', textAlign: 'center' }} />
                <Column field="TOTAL_SERVICIOS_SUMA" header="Servicios Suma" sortable style={{ width: '75px', textAlign: 'center' }} />
                <Column field="TOTAL_SERVICIOS_ALIADO" header="Servicios Aliado" sortable style={{ width: '80px', textAlign: 'center' }} />
                <Column header="" body={accionesTpl} style={{ width: '90px', textAlign: 'center' }} frozen alignFrozen="right" />
            </DataTable>
        </GlovalCard>
    );
};

export default TablaCierres;
